module.exports = __webpack_public_path__ + "21fb80f699b09209289a59ba5c12a45d.ttf";